import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutProject.css";
import mer from "../assets/MER-laderhack.png";
import apiRest from "../assets/API-REST.png";

function AboutUs() {
  return (
    <div>
      <div className="breadcrumbs wow fadeInUp">
        <div className="container">
          <div className="breadcrumbs-content">
            <h2 className="text-center">
              About this project &amp; the team behind
            </h2>
          </div>
        </div>
      </div>
      <section>
        <div className="container">
          <div
            id="row-resume"
            className="row d-flex justify-content-center px-5"
          >
            <div className="col-9 pt-65 pb-5 ps-0">
              <h5 className="text-secondary h5-font-size">
                Creamos Läderhack como proyecto final de nuestro Coding Bootcamp
                realizado en Hack Academy entre los meses de marzo y julio del
                2022. Nos pidieron que realizaramos un e-commerce en un período
                de 3 semanas y que lo desarrollaramos como un equipo de 4
                integrantes. Las principales tecnologías que utilizamos fueron
                React.js para el Front-End, Node.js y Express.js para el
                Back-End y MongoDB para la Base de Datos. Tomamos como
                referencia e inspiración el sitio oficial de
                <a
                  style={{
                    color: `rgb(213,179,117)`,
                  }}
                  className="mx-1 text-decoration-none"
                  href="https://laderach.com/"
                >
                  Läderach.
                </a>
              </h5>
            </div>
          </div>
          <div className="container mt-4 mb-5 px-5">
            <div className="row d-flex justify-content-between">
              <div className="col-4 ps-0 width-30 border-top border-2 pt-4">
                <h6 className="text-start fw-bold">Metodología</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Empleamos la metodología SCRUM. Durante el transcurso del
                  trabajo pasamos por 3 Sprints, uno por semana, y cada uno de
                  ellos fue finalizado con una DEMO para mostrar los avances
                  logrados.
                </p>
              </div>
              <div className="col-4 ps-0 width-30 border-top border-2 pt-4">
                <h6 className="text-start fw-bold">Organización</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Para nuestro equipo fue fundamental dividirnos las tareas.
                  Para ello nos apoyamos en la herramienta de proyectos de
                  GitHub. Fue de gran ayuda para marcarnos objetivos cortos y
                  claros.
                </p>
              </div>
              <div className="col-4 ps-0 width-30 border-top border-2 pt-4">
                <h6 className="text-start fw-bold">Tecnologías</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  HTML5, CSS, JavaScript(ES6+), Bootstrap, React.js, Redux,
                  Node.js, Express.js, JSON Web Token, mongoDB, mongoose,
                  Vercel, Supabase, Atlas, git, GitHub, GitHub Desktop.
                </p>
              </div>
            </div>
          </div>
          <div className="container px-5">
            <div className="row pt-60 pb-5  d-flex justify-content-between">
              <div className="col-4 width-30   ps-0">
                <h6 className="text-start fw-bold">MER</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  En la primera etapa del proyecto realizamos un diagrama MER
                  para definir las entidades que consideramos necesarias y
                  establecer sus respectivas relaciones.
                </p>
                <h6 className="text-start fw-bold">Entidades</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Las entidades definidas fueron Product, Category, Order, Buyer
                  y Admin. Debido al alcanze del proyecto y para reducir
                  complejidad, decidimos que Buyer y Admin fueran entidades
                  independientes.
                </p>
                <h6 className="text-start fw-bold">Relaciones</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Un producto puede estar en muchas órdenes y cada una de éstas
                  pueden tener muchos productos. Una categoría puede tener
                  muchos productos, pero un producto solo podrá estar en una
                  categoría. El cliente podrá tener muchas órdenes pero cada
                  orden pertenecerá a un solo cliente.
                </p>
              </div>
              <div className="col-8 width-60-mer d-flex align-items-center">
                <img src={mer} alt="" />
              </div>
            </div>
            <div className="row mt-4 pt-5 pb-5 d-flex justify-content-between">
              <div className="col-8 width-60-api d-flex align-items-center">
                <img src={apiRest} alt="" />
              </div>
              <div className="col-4 width-30   ">
                <h6 className="text-start fw-bold">Front-End</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Creimos conveniente crear dos proyectos de Front
                  independientes. Uno para el e-commerce y otro para la
                  Administración. Las principales tecnologías utilizadas fueron
                  React.js, Redux y React-Router.
                </p>
                <h6 className="text-start fw-bold">Back-End</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Nos basamos en un entorno de Node.js con Express.js. A través
                  de JWT generamos dos tokens distintos para diferenciar el
                  acceso de un cliente al de un administrador.
                </p>
                <h6 className="text-start fw-bold">Base de Datos</h6>
                <p className="text-start text-secondary p-font-size pt-1">
                  Optamos por usar mongoDB para nuestra Base de Datos, ya que
                  tenemos más afinidad con el desarrollo en mongoose.
                </p>
              </div>
            </div>
            <div className="container  px-5 border rounded-3 bg-white  mt-85 mb-5">
              <div className="row pt-5 pb-5 d-flex justify-content-between">
                <div className="col-md-9 ps-0">
                  <h2 className="text-start fw-bold">
                    Querés entrar como Administrador?
                  </h2>
                  <h2 id="probalo" className="text-start fw-bold">
                    Te damos la credenciales.
                  </h2>
                </div>
                <div
                  id="call-to-action-a-div"
                  className="col-md-3 d-flex align-items-center justify-content-end"
                >
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://laderhack-admin-ha.vercel.app"
                    className="btn btn-dark w-100 fs-5 fw-bold"
                  >
                    Ir a Admin
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section class="about-us section wow fadeInUp">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="content-left">
                <img
                  src="https://laderach.com/media/wysiwyg/FrischSchoggi_Berg_01.png"
                  alt="#"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="content-right">
                <p className="text-start text-about-project">
                  We created LaderHack as the final project of the Coding
                  Bootcamp of Hack Academy. We were asked to create an
                  e-commerce in a three week period and we would have to do
                  develop it as a team of four.
                </p>
                <p className="text-start text-about-project">
                  The technologies used for the project were React, express and
                  MongoDB and we used as a reference the website of
                  <a
                    style={{
                      color: `rgb(213,179,117)`,
                    }}
                    className="mx-1"
                    href="https://laderach.com/"
                  >
                    Läderach.
                  </a>
                </p>
                <p className="text-start text-about-project">
                  The project is composed of three parts. The first one is the
                  user interface in which the user can register, login, browse
                  the products and see detailed information about them, filter
                  by categories, add items to the cart (even if they are not
                  logged), checkout (once logged) to generate the order and pay
                  it.
                </p>
                <p className="text-start text-about-project">
                  The second component is the adminsitration dashboard in which
                  administrators will be able to create, edit and delete
                  products, categories and administrators users. They will also
                  be able to get a detail of the orders generated in the
                  website.
                </p>
                <p className="text-start text-about-project">
                  The last one is the API REST with the objective of connecting
                  the frontend with the backend and store the data in the
                  database.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="team section pt-60 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title">
                <h2
                  className="wow fadeInUp mb-60 fw-normal fs-2"
                  data-wow-delay=".4s"
                >
                  Nuestro Equipo
                </h2>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-team first-single-team">
                <div className="image">
                  <img
                    src="../img/mate.jpg"
                    alt="#"
                    className="card-img-top rounded-circle fs-1"
                  />
                </div>
                <div className="content">
                  <div className="info">
                    <h3
                      className="mt-3"
                      style={{
                        fontSize: `16px`,
                        fontWeight: `500`,
                        fontStyle: `normal`,
                        color: `#444`,
                      }}
                    >
                      Mateo Casciotti
                    </h3>
                    <h5
                      className="mb-2"
                      style={{
                        fontSize: `14px`,
                        fontWeight: `400`,
                        fontStyle: `normal`,
                      }}
                    >
                      Fullstack Developer
                    </h5>
                    <ul className="social d-flex justify-content-center mt-0">
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/in/mateo-casciotti/"
                        >
                          <i className="fa-brands fa-linkedin fs-5"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://github.com/MattMattej"
                        >
                          <i className="fa-brands fa-github fs-5"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12">
              <div id="micaela-single-team" className="single-team">
                <div className="image">
                  <img
                    src="../img/mica.jpg"
                    alt="#"
                    className="card-img-top rounded-circle"
                  />
                </div>
                <div className="content">
                  <div className="info">
                    <h3
                      className="mt-3"
                      style={{
                        fontSize: `16px`,
                        fontWeight: `500`,
                        fontStyle: `normal`,
                        color: `#444`,
                      }}
                    >
                      Micaela Gioia
                    </h3>
                    <h5
                      className="mb-2"
                      style={{
                        fontSize: `14px`,
                        fontWeight: `400`,
                        fontStyle: `normal`,
                      }}
                    >
                      Fullstack Developer
                    </h5>
                    <ul className="social d-flex justify-content-center mt-0">
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/in/micaela-gioia/"
                        >
                          <i className="fa-brands fa-linkedin fs-5"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://github.com/gioiamicaela"
                        >
                          <i className="fa-brands fa-github fs-5"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12">
              <div id="federico-single-team" className="single-team">
                <div className="image">
                  <img
                    src="../img/fede3.png"
                    alt="#"
                    className="card-img-top-fede rounded-circle"
                  />
                </div>
                <div className="content">
                  <div className="info">
                    <h3
                      className="mt-3"
                      style={{
                        fontSize: `16px`,
                        fontWeight: `500`,
                        fontStyle: `normal`,
                        color: `#444`,
                      }}
                    >
                      Federico Montero
                    </h3>
                    <h5
                      className="mb-2"
                      style={{
                        fontSize: `14px`,
                        fontWeight: `400`,
                        fontStyle: `normal`,
                      }}
                    >
                      React Developer
                    </h5>
                    <ul className="social d-flex justify-content-center mt-0">
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/in/fede-montero/"
                        >
                          <i className="fa-brands fa-linkedin fs-5"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://github.com/federicomontero86"
                        >
                          <i className="fa-brands fa-github fs-5"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12">
              <div id="axel-single-team" className="single-team">
                <div className="image">
                  <img
                    src="../img/axel.jpg"
                    alt="#"
                    className="card-img-top rounded-circle"
                  />
                </div>
                <div className="content">
                  <div className="info">
                    <h3
                      className="mt-3"
                      style={{
                        fontSize: `16px`,
                        fontWeight: `500`,
                        fontStyle: `normal`,
                        color: `#444`,
                      }}
                    >
                      Axel Rasmussen
                    </h3>
                    <h5
                      className="mb-2"
                      style={{
                        fontSize: `14px`,
                        fontWeight: `400`,
                        fontStyle: `normal`,
                      }}
                    >
                      Fullstack Developer
                    </h5>
                    <ul className="social d-flex justify-content-center mt-0">
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/in/axel-rasmussen-toniolo/"
                        >
                          <i className="fa-brands fa-linkedin fs-5"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://github.com/rasmussenToniolo"
                        >
                          <i className="fa-brands fa-github fs-5"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
